import mutations from './mutations'
import actions from './actions'

const admin = {
    namespaced: true,
    state: {
        admins: [],
        isLoaded: false,
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        filters: {
            fromDate: null,
            toDate: null,
            email: null,
            name: null
        }
    },
    mutations,
    actions
}

export default admin
